import { VStack, Grid, Box, Text } from '@chakra-ui/react'
import { FormProvider } from 'react-hook-form'
import { OptionsSelect } from '../OptionsSelect'
import { CustomSelect } from '../CustomSelect'
import { ObservacoesForm } from '../ObservacoesForm'
import { DataHoraForm } from '../DataHoraForm'
import { useFormAgendamento } from './useFormAgendamento'
import { Button } from '../../../../../../../../components/Button'

export function FormAgendamento({ numeroNota, infoProposta, onSend, onSubmitSuccess, agendarRetorno, pedidoBloqueado }) {
  const { methods, agendamentoTipo, handleSubmit, onChangeSelect } = useFormAgendamento({
    numeroNota,
    infoProposta,
    onSend,
    agendarRetorno,
    onSubmitSuccess,
  })

  return (
    <FormProvider {...methods}>
      <VStack spacing={4} maxW="963px" w="full" mx="auto">
        <ObservacoesForm />
        <Text fontWeight="bold" textAlign="center" fontSize="15px">
          Como você deseja retornar o contato?
        </Text>
        <Grid gridTemplateColumns="repeat(4,1fr)" gap={2} w="100%">
          <Box w="full">
            <CustomSelect onChange={onChangeSelect} value={agendamentoTipo} />
          </Box>
          <DataHoraForm />
          <Box w="full">
            <Button isLoading={agendarRetorno.isLoading} w="100%" borderRadius="6px" bgColor="#378BBF" fontSize="15px" onClick={handleSubmit} disabled={pedidoBloqueado}>
              adicionar agendamento
            </Button>
          </Box>
        </Grid>
        <OptionsSelect optionSelected={agendamentoTipo} />
      </VStack>
    </FormProvider>
  )
}
